// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FiltersLabelOptionsTemplate_tf6Gj {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  box-sizing: border-box;
  p {
    margin: 0;
    color: #292a2b;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  input {
    background-color: var(--f5-background);
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 32px;
    border-radius: 4px;
    padding: 0px 18px;
    font-family: "Inter", sans-serif;
    border: none;
    outline: none;
    box-sizing: border-box;
  }
  .transparentBG_IeAAl {
    background-color: transparent;
    border: 1px solid var(--d9-background);
  }
  .carouselContainer_rJzBt {
    position: relative;
    width: 100%;
  }
  .carousel_Ehv5c {
    position: absolute;
    top: 116%;
    left: 0;
    z-index: 1;
  }


  .chevronIcon_EkP3K {
    color: var(--_71717a-color);
    padding: 0px 6px;
  }


  .inputWrapper_r6waQ{
    display: flex;
    align-items: center;
    border: 1px solid #D9D9E3;
    border-radius: 8px;
    padding: 0 10px;
    gap: 5px;
    input{
      background-color: transparent;
      padding: 0px;

    }
  }

  .variablesContainer_aluqS{
    background-color: var(--white-background);
    border: 1px solid var(--_e6-color);
    border-radius: 8px;
    position: absolute;
    top: 100%;
    width: 100%;
    z-index: 999;
    max-height: 200px;
    overflow-y: scroll;

  }
  .variablesContent_Zp96v{
    padding: 5px 8px;
    display: flex;
    gap: 5px;
    /* border: 1px solid var(--_e6-color); */
    align-items: center;
    p{
      color: var(--_2-color);
      margin: 0;
      span{
        margin: 0;
        background-color: #656b74;
        border-radius: 8px;
        color: var(--white-color);
        padding: 3px 10px;
        font-size: 9px;
      }
    }
    >div >span{
      color: #000000;
      font-weight: 300;
    }

&:first-child {
border-top-left-radius: 8px;
border-top-right-radius: 8px;
}


&:last-child {
border-bottom-left-radius: 8px;
border-bottom-right-radius: 8px;
}
  }

  .btnNewVariable_z_7i9{
    background-color: var(--f5-background);
    width: 100%;
    border: none;
    outline: none;
    border-radius: 8px;
    padding: 10px;
    text-align: start;
    box-sizing: border-box;
    color: #666666;
    cursor: pointer;
  }
}

.inputVariablesContainer_QVgWi{
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Automate/Components/FiltersLabelOptionsTemplate/FiltersLabelOptionsTemplate.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,sBAAsB;EACtB;IACE,SAAS;IACT,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,sCAAsC;IACtC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,gCAAgC;IAChC,YAAY;IACZ,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,6BAA6B;IAC7B,sCAAsC;EACxC;EACA;IACE,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,UAAU;EACZ;;;EAGA;IACE,2BAA2B;IAC3B,gBAAgB;EAClB;;;EAGA;IACE,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,QAAQ;IACR;MACE,6BAA6B;MAC7B,YAAY;;IAEd;EACF;;EAEA;IACE,yCAAyC;IACzC,kCAAkC;IAClC,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;;EAEpB;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,QAAQ;IACR,wCAAwC;IACxC,mBAAmB;IACnB;MACE,sBAAsB;MACtB,SAAS;MACT;QACE,SAAS;QACT,yBAAyB;QACzB,kBAAkB;QAClB,yBAAyB;QACzB,iBAAiB;QACjB,cAAc;MAChB;IACF;IACA;MACE,cAAc;MACd,gBAAgB;IAClB;;AAEJ;AACA,2BAA2B;AAC3B,4BAA4B;AAC5B;;;AAGA;AACA,8BAA8B;AAC9B,+BAA+B;AAC/B;EACE;;EAEA;IACE,sCAAsC;IACtC,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".FiltersLabelOptionsTemplate {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  align-self: stretch;\n  box-sizing: border-box;\n  p {\n    margin: 0;\n    color: #292a2b;\n    font-family: Inter;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }\n  input {\n    background-color: var(--f5-background);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 32px;\n    border-radius: 4px;\n    padding: 0px 18px;\n    font-family: \"Inter\", sans-serif;\n    border: none;\n    outline: none;\n    box-sizing: border-box;\n  }\n  .transparentBG {\n    background-color: transparent;\n    border: 1px solid var(--d9-background);\n  }\n  .carouselContainer {\n    position: relative;\n    width: 100%;\n  }\n  .carousel {\n    position: absolute;\n    top: 116%;\n    left: 0;\n    z-index: 1;\n  }\n\n\n  .chevronIcon {\n    color: var(--_71717a-color);\n    padding: 0px 6px;\n  }\n\n\n  .inputWrapper{\n    display: flex;\n    align-items: center;\n    border: 1px solid #D9D9E3;\n    border-radius: 8px;\n    padding: 0 10px;\n    gap: 5px;\n    input{\n      background-color: transparent;\n      padding: 0px;\n\n    }\n  }\n\n  .variablesContainer{\n    background-color: var(--white-background);\n    border: 1px solid var(--_e6-color);\n    border-radius: 8px;\n    position: absolute;\n    top: 100%;\n    width: 100%;\n    z-index: 999;\n    max-height: 200px;\n    overflow-y: scroll;\n\n  }\n  .variablesContent{\n    padding: 5px 8px;\n    display: flex;\n    gap: 5px;\n    /* border: 1px solid var(--_e6-color); */\n    align-items: center;\n    p{\n      color: var(--_2-color);\n      margin: 0;\n      span{\n        margin: 0;\n        background-color: #656b74;\n        border-radius: 8px;\n        color: var(--white-color);\n        padding: 3px 10px;\n        font-size: 9px;\n      }\n    }\n    >div >span{\n      color: #000000;\n      font-weight: 300;\n    }\n\n&:first-child {\nborder-top-left-radius: 8px;\nborder-top-right-radius: 8px;\n}\n\n\n&:last-child {\nborder-bottom-left-radius: 8px;\nborder-bottom-right-radius: 8px;\n}\n  }\n\n  .btnNewVariable{\n    background-color: var(--f5-background);\n    width: 100%;\n    border: none;\n    outline: none;\n    border-radius: 8px;\n    padding: 10px;\n    text-align: start;\n    box-sizing: border-box;\n    color: #666666;\n    cursor: pointer;\n  }\n}\n\n.inputVariablesContainer{\n  position: relative;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"FiltersLabelOptionsTemplate": `FiltersLabelOptionsTemplate_tf6Gj`,
	"transparentBG": `transparentBG_IeAAl`,
	"carouselContainer": `carouselContainer_rJzBt`,
	"carousel": `carousel_Ehv5c`,
	"chevronIcon": `chevronIcon_EkP3K`,
	"inputWrapper": `inputWrapper_r6waQ`,
	"variablesContainer": `variablesContainer_aluqS`,
	"variablesContent": `variablesContent_Zp96v`,
	"btnNewVariable": `btnNewVariable_z_7i9`,
	"inputVariablesContainer": `inputVariablesContainer_QVgWi`
};
export default ___CSS_LOADER_EXPORT___;
